/**
 * Whether something thrown is a cancelled request rather than a failure.
 *
 * Apollo rejects a pending `refetch`, `fetchMore` or lazy query with one when
 * the component that asked for it unmounts, and `fetch` does the same for an
 * aborted signal. Nothing has gone wrong in either case.
 */
export function isAbortError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    (error as { name?: unknown }).name === 'AbortError'
  );
}
